export const buildValidationObject = (questions) => {
    let validationObject = {};

    Object.entries(questions).forEach(([key, value]) => {
        validationObject[value.name] = value.validation;

        if (value.children) {
            const childValidationObject = buildValidationObject(value.children);
            validationObject = { ...validationObject, ...childValidationObject };
        }

        if (value.option) {
            value.option.forEach((option) => {
                if (option.children) {
                    const childValidationObject = buildValidationObject(option.children);
                    validationObject = { ...validationObject, ...childValidationObject };
                }
                if (option.name && option.validation) {
                    // Purpose: if need to have multiple textfield in one question
                    validationObject[option.name] = option.validation;
                }
            });
        }
    });

    return validationObject;
};
